/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */

import {Directive, DoCheck, ElementRef, KeyValueChangeRecord, KeyValueDiffer, KeyValueDiffers, Renderer} from '@angular/core';

import {isBlank, isPresent} from '../facade/lang';
export class NgStyle implements DoCheck {
  /** @internal */
  _rawStyle: {[key: string]: string};
  /** @internal */
  _differ: KeyValueDiffer;

  constructor(
      private _differs: KeyValueDiffers, private _ngEl: ElementRef, private _renderer: Renderer) {}

  set rawStyle(v: {[key: string]: string}) {
    this._rawStyle = v;
    if (isBlank(this._differ) && isPresent(v)) {
      this._differ = this._differs.find(this._rawStyle).create(null);
    }
  }

  ngDoCheck() {
    if (isPresent(this._differ)) {
      var changes = this._differ.diff(this._rawStyle);
      if (isPresent(changes)) {
        this._applyChanges(changes);
      }
    }
  }

  private _applyChanges(changes: any): void {
    changes.forEachAddedItem(
        (record: KeyValueChangeRecord) => { this._setStyle(record.key, record.currentValue); });
    changes.forEachChangedItem(
        (record: KeyValueChangeRecord) => { this._setStyle(record.key, record.currentValue); });
    changes.forEachRemovedItem(
        (record: KeyValueChangeRecord) => { this._setStyle(record.key, null); });
  }

  private _setStyle(name: string, val: string): void {
    this._renderer.setElementStyle(this._ngEl.nativeElement, name, val);
  }
/** @nocollapse */
static decorators: DecoratorInvocation[] = [
{ type: Directive, args: [{selector: '[ngStyle]', inputs: ['rawStyle: ngStyle']}, ] },
];
/** @nocollapse */
static ctorParameters: {type: Function, decorators?: DecoratorInvocation[]}[] = [
{type: KeyValueDiffers, },
{type: ElementRef, },
{type: Renderer, },
];
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
